/**
 * Primary-key extraction for raw master-data tables.
 *
 * For composite-PK tables, the column list is hard-coded so callers can build
 * a `{ pk: { col: value, ... } }` payload for `crud op:update / op:delete`.
 *
 * Single-PK tables fall through to `['id']` by default; tables whose single PK
 * is not literally `id` (e.g. `product.product_id`, `map.id`, `pet_grade.grade`)
 * are listed explicitly.
 */
const COMPOSITE: Record<string, string[]> = {
  stage_wave: ['stage_id', 'wave_number'],
  stage_wave_enemy: ['stage_id', 'wave_number', 'enemy_id'],
  league_table: ['id'],
  league_table_wave: ['league_table_id', 'wave_number'],
  league_table_wave_enemy: ['league_table_id', 'wave_number', 'enemy_id'],
  league_season: ['id'],
  valhalla_season: ['id'],
  valhalla_wave: ['valhalla_id', 'wave_number'],
  valhalla_wave_enemy: ['valhalla_id', 'wave_number', 'enemy_id'],
  degen_league_wave: ['wave_number'],
  degen_league_wave_enemy: ['wave_number', 'enemy_id'],
  pet_upgrade: ['pet_id', 'level'],
  pet_summon_probability: ['level', 'summon_type', 'pet_id'],
  quest_milestone: ['id'],
  item_group: ['wave_shop_config_id', 'item_id'],
  meta_tag_synergy: ['meta_tag_id', 'level'],
  league_reward: ['reward_table_id', 'min_rank'],
  skill: ['skill_type', 'level'],
  attendance_reward: ['id'],
  event_attendance: ['id'],
  pet_summon_level: ['level'],
  pet_summon_config: ['id'],
  pet_grade: ['grade'],
  degen_conditional_count_prob: ['difficulty'],
  map: ['id'],
  product: ['product_id'],
  entitlement: ['type'],
};

export function derivePkColumns(table: string): string[] {
  return COMPOSITE[table] ?? ['id'];
}

export function derivePk(row: Record<string, unknown>, table: string): Record<string, unknown> {
  const keys = derivePkColumns(table);
  const out: Record<string, unknown> = {};
  for (const k of keys) out[k] = row[k];
  return out;
}
